import dealsHelper from '@/libs/deals';
import perms from '@/libs/permissions';
import { LOANS_WRITE } from '@/libs/permissions_list';

export default {
  computed: {
    isChangeOrderAllowed() {
      return ((dealsHelper.isActive(this.loan) || dealsHelper.isInProgress(this.loan)) &&
        this.hasEstimateOfRepairs && perms.checkPermissions([LOANS_WRITE]));
    },
    hasEstimateOfRepairs() {
      if (this.loan.documents !== undefined) {
        const eorDoc = this.loan.documents.standard.find(doc => doc.type === 'Estimate of Repairs');
        return eorDoc && (eorDoc.submittedCount > 0 || eorDoc.approvedCount > 0);
      }
      return !this.loan.needed_files.includes('estimate_of_repairs');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/change_order/ChangeOrderMixin.js